module.exports = __webpack_public_path__ + "media/images/flags/32/Sri-Lanka-3700adc5d7e42e1f5753f6124444b686.png";